// extracted by mini-css-extract-plugin
module.exports = {"sideBanner":"style_sideBanner__69IGa"};